const styles = (theme) => ({
  containerAvatar: {
    mr: 1,
    width: 40,
    height: 40,
  },
  colorTitle: {
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    fontSize: "0.75rem",
  },
  boxContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  value: {
    fontWeight: 700,
    lineHeight: 1,
  },
  containerCard: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
});

export default styles;
